import * as React from "react";

function HashtagIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m424 136-74.01-.025 13.63-75.76c2.344-13.03-6.312-25.53-19.38-27.88-13-2.188-25.5 6.344-27.88 19.38l-15.16 84.26H190l13.63-75.76c2.344-13.03-6.312-25.53-19.38-27.88C171.2 30.15 158.7 38.69 156.4 51.72l-15.16 84.26H56c-13.25 0-24 10.78-24 24.03 0 13.25 10.75 23.97 24 23.97h76.57l-25.92 144H24c-13.25 0-24 10.76-24 24.01C0 365.3 10.75 376 24 376l74.01-.008-13.63 75.76c-2.344 13.03 6.312 25.53 19.38 27.88 1.44.268 2.84.368 4.24.368 11.38 0 21.5-8.158 23.59-19.75l15.16-84.26h111.2l-13.63 75.76c-2.344 13.03 6.312 25.53 19.38 27.88 1.5.27 2.9.37 4.3.37 11.38 0 21.5-8.158 23.59-19.75l15.16-84.26L392 376c13.25 0 24-10.75 24-23.1 0-13.25-10.75-24.01-24-24.01h-76.57l25.92-144L424 184c13.25 0 24-10.75 24-23.1 0-14.1-10.7-24.9-24-24.9zM266.7 327.1H155.5l25.92-144h111.2l-25.92 144z"
  }));
}

const ForwardRef = React.forwardRef(HashtagIcon);
export default ForwardRef;